const DATEV_API_BASE_PATH = `/payroll_integrations/datev_api`
export const STATUS_PATH = `${DATEV_API_BASE_PATH}/auth/status`
export const LOGIN_PATH = `${DATEV_API_BASE_PATH}/auth/login`
export const RELINK_PATH = `${DATEV_API_BASE_PATH}/auth/relink`
export const ACTIVATE_PATH = `${DATEV_API_BASE_PATH}/auth/activate`
export const SUPPLEMENTS_PATH = `${DATEV_API_BASE_PATH}/supplements`
